// extracted by mini-css-extract-plugin
module.exports = {"videoStimulus":"style-module__videoStimulus___3AEO9"};